import Cookies from 'js-cookie'
import ZwxSm from './sm'

/**
 * 添加Cookie
 * expires为undefined时代表随浏览器关闭而失效
 * */
let addCookie = (key, value, expires, domain) => {
  if (value === null || value === undefined) return delCookie(key, domain)
  value = String(value)
  let attributes = { path: '/' }
  if (expires) attributes.expires = expires
  if (domain) attributes.domain = domain
  Cookies.set(key, ZwxSm.sm4JsEncrypt(value), attributes)
}

/**
 * 获取Cookie
 * */
let getCookie = key => {
  return ZwxSm.sm4JsDecrypt(Cookies.get(key))
}

/**
 * 获取Cookie，不存在给默认值
 * */
let getCookieDefault = (key, defaultValue) => {
  const value = getCookie(key)
  if (value === undefined || value === null) return defaultValue
  return value
}

/**
 * 删除Cookie
 * */
let delCookie = (key, domain) => {
  let attributes = { path: '/' }
  if (domain) attributes.domain = domain
  Cookies.remove(key, attributes)
}

export default { addCookie, getCookie, getCookieDefault, delCookie }
